export enum BatteryState {
    OFF = 'OFF',
    INITIALIZING = 'INITIALIZING',
    CHARGING = 'CHARGING',
    DISCHARGING = 'DISCHARGING',
    OFFGRID_DISCHARGING = 'OFFGRID_DISCHARGING',
    UNPLUGGED = 'UNPLUGGED',
    NOT_SUPPORTED = 'NOT_SUPPORTED',
    DEVICE_OFF = 'DEVICE_OFF',
}
